import React from "react";
import { FadeLoader, BounceLoader } from "react-spinners";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "black",
};

const Loader = ({ color, size }) => {
  return (
    <>
      <BounceLoader
        color={color || "#FF6821"}
        loading={true}
        cssOverride={override}
        size={size || 60}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </>
  );
};

export default Loader;
